export const ACCESS_TOKEN_KEY = 'ENID_ACCESS_TOKEN';
export const AUTH_PLATFORM_KEY = 'ENID_PLATFORM';
export const MY_INFO_ACCESS_DATA_KEY = 'my_info_access';
export const MY_INFO_SNS_TOKEN = 'MY_INFO_SNS_TOKEN';
export const WITHDRAW_SNS_TOKEN = 'WITHDRAW_SNS_TOKEN';
